<div class="scaffold-wizard-holder" [ngClass]="{'tab-style-wizard':item.use_tab_style}">
  <h2>{{item.translation_key||item.title| translation|translationFromString | transformText :item?.text_transform}}</h2>
  <p-stepper *ngIf="item.direction!=='vertical'" #stepper [linear]="false" [value]="selectedStep">
    <p-step-list>
      <p-step *ngFor="let step of item.tabs; let $index = index" [value]="$index">{{step.heading}}</p-step>
    </p-step-list>
    <p-step-panels>
      <p-step-panel *ngFor="let step of item.tabs; let $index = index" [label]="step.heading" [value]="$index">
        <ng-template #content let-activateCallback="activateCallback">
          <div>
            <app-view [active]="selectedStep === $index" [childview]="item.childview || childview" [info]="info"
              [items]="step.content" [data]="data" (openViewHandler)="openViewHandler($event, ite)"
              (moveHandler)="openMove()" (openLinkHandler)="openLinkHandler($event, ite)"></app-view>
          </div>
          <div>
            <button pButton color="primary" [disabled]="$index===0"
              (click)="activateCallback($index-1)"><span>{{'previous'| translation}}</span><span *ngIf="$index > 0">:
                {{item.tabs[$index - 1].translation_key_label||item.tabs[$index - 1].heading|
                translation|translationFromString | transformText :item?.text_transform_label}}</span></button>
            <button pButton color="primary" [disabled]="$index >= item.tabs.length-1" class="pull-right"
              (click)="activateCallback($index+1)"><span>{{'next'| translation}}</span><span
                *ngIf="$index < item.tabs.length-1">: {{item.tabs[$index + 1].translation_key_label||item.tabs[$index +
                1].heading| translation|translationFromString | transformText
                :item?.text_transform_label}}</span></button>
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-panels>
  </p-stepper>
  <p-stepper *ngIf="item.direction==='vertical'" #stepper [linear]="false" [value]="selectedStep">
    <p-step-item *ngFor="let step of item.tabs; let $index = index" [value]="$index">
      <p-step>{{step.heading}}</p-step>
      <p-step-panel>
        <ng-template #content let-activateCallback="activateCallback">
        <div>
          <app-view [active]="selectedStep === $index" [childview]="item.childview || childview" [info]="info"
            [items]="step.content" [data]="data" (openViewHandler)="openViewHandler($event, ite)"
            (moveHandler)="openMove()" (openLinkHandler)="openLinkHandler($event, ite)"></app-view>
        </div>
        <div>
          <button pButton color="primary" [disabled]="$index===0" 
          (click)="activateCallback($index-1)"><span>{{'previous'|
              translation}}</span><span *ngIf="$index > 0">: {{item.tabs[$index -
              1].translation_key_label||item.tabs[$index - 1].heading| translation|translationFromString | transformText
              :item?.text_transform_label}}</span></button>
          <button pButton color="primary" [disabled]="$index >= item.tabs.length-1" class="pull-right"
            (click)="activateCallback($index+1)"><span>{{'next'| translation}}</span><span
              *ngIf="$index < item.tabs.length-1">: {{item.tabs[$index + 1].translation_key_label||item.tabs[$index +
              1].heading| translation|translationFromString | transformText
              :item?.text_transform_label}}</span></button>
        </div>
        </ng-template>
      </p-step-panel>
    </p-step-item>
  </p-stepper>

</div>